import "./style.css"

export const Container = ({ children, maxWidth = "1200px" }) => {

	return (
		<div className="container" style={{ maxWidth }}>
			{children}
		</div>
	)
}
